import React from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  return <img src={`https://app.kaspafinance.io/images/chains/KAS.png`} width={28} height={28} />;
};

export default Icon;
